'use client';
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var getContainerSpec = function(theme, shades) {
    var base = shades.base || shades[600];
    return _extends({}, theme.fn.deriveStates(base, "color"), {
        default: base,
        disabled: shades.mid || shades[200],
        focus: shades.mid || shades[200]
    });
};
var getLabelSpec = function(theme, _shades, options) {
    return function(state) {
        if (state === "disabled") {
            return theme.palette.text.inverted;
        }
        if ((options == null ? void 0 : options.textColor) !== undefined) {
            return theme.fn.primaryShade(theme.fn.themeColor(options.textColor));
        }
        return theme.palette.text.onColor;
    };
};
var defaultVariant = function(theme, options) {
    var _theme_fn = theme.fn, deriveShades = _theme_fn.deriveShades, themeColor = _theme_fn.themeColor;
    var shades = deriveShades(themeColor(options == null ? void 0 : options.color, theme.palette.primary));
    return {
        container: getContainerSpec(theme, shades),
        label: getLabelSpec(theme, shades, options)
    };
};
var deriveStatesOverlay = {
    translucent: "stronger",
    secondary: "light",
    outline: "light",
    ghost: "light"
};
var createVariant = function(variant) {
    return function(theme, options) {
        var _theme_palette = theme.palette, border = _theme_palette.border, button = _theme_palette.button, text = _theme_palette.text;
        var _theme_fn = theme.fn, deriveShades = _theme_fn.deriveShades, themeColor = _theme_fn.themeColor;
        var shades = null;
        if ((options == null ? void 0 : options.color) || (options == null ? void 0 : options.textColor)) {
            shades = deriveShades(themeColor(options == null ? void 0 : options.color, theme.palette.primary));
        }
        var containerBackground = {
            white: button.white,
            secondary: button.secondary,
            outline: "transparent",
            ghost: "transparent",
            translucent: button.translucent
        }[variant];
        return {
            container: (options == null ? void 0 : options.color) ? getContainerSpec(theme, shades) : _extends({}, variant !== "white" && theme.fn.deriveStates(containerBackground, deriveStatesOverlay[variant]), {
                default: containerBackground,
                disabled: variant === "outline" || variant === "ghost" ? "transparent" : variant === "translucent" ? button.translucent : button.secondary,
                focus: border.element
            }),
            label: (options == null ? void 0 : options.textColor) ? getLabelSpec(theme, shades, options) : function(state) {
                switch(variant){
                    case "translucent":
                        return state === "disabled" ? text.secondary : text.inverted;
                    case "white":
                        return state === "disabled" ? text.tertiary : text.medium;
                    default:
                        return state === "disabled" ? text.tertiary : text.primary;
                }
            }
        };
    };
};
var lookup = {
    default: defaultVariant,
    white: createVariant("white"),
    secondary: createVariant("secondary"),
    outline: createVariant("outline"),
    ghost: createVariant("ghost"),
    translucent: createVariant("translucent")
};
var getVariantStyles = function(theme, param) {
    var color = param.color, textColor = param.textColor, variant = param.variant;
    return (variant && lookup[variant] ? lookup[variant] : defaultVariant)(theme, {
        color: color,
        textColor: textColor
    });
};

export { createVariant, defaultVariant, deriveStatesOverlay, getContainerSpec, getLabelSpec, getVariantStyles };
